/* eslint-disable @typescript-eslint/no-explicit-any */

import { CommonModule } from '@angular/common';
import { Component, inject, input, signal, TemplateRef, ChangeDetectionStrategy } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'mdw-choice-list',
  templateUrl: './choice-list.html',
  styleUrls: ['./choice-list.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [CommonModule],
})
export class MdwChoiceList implements ControlValueAccessor {
  public ngControl = inject(NgControl, { self: true });

  public label = input<string>();
  public description = input<string>();
  public multiSelect = input<boolean>();
  public choices = input([] as Array<{ label: string; value: string | number | boolean }>);
  public trailingItemTemplate = input<TemplateRef<any>>();
  public itemDisplayMode = input<'default' | 'tall'>('default');

  public isDisabled = signal(false);
  public selectedValues = signal([] as Array<string | number | boolean>);
  public get value() {
    return this._value;
  }
  public set value(val: Array<string | number | boolean>) {
    this._value = val;
    this.selectedValues.set(val);
  }
  private _value = [] as Array<string | number | boolean>;

  // eslint-disable-next-line @typescript-eslint/no-empty-function, @typescript-eslint/no-unused-vars
  onChange = (_: any) => {};
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  public get errorMessages() {
    const errors = this.ngControl.control?.errors;
    const errorMessages = [] as string[];

    if (!errors) {
      return errorMessages;
    } else {
      Object.keys(errors).forEach(key => {
        const error = 'There seems to be an error with this field.';

        switch (key) {
          case 'required': {
            errorMessages.push('Please select an item.');
            break;
          }
          default: {
            errorMessages.push(error);
          }
        }
      });
    }

    return errorMessages;
  }

  constructor() {
    this.ngControl.valueAccessor = this;
  }

  public writeValue(value: any): void {
    this.value = value ?? [];
  }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.isDisabled.set(isDisabled);
  }

  public toggleSelection(option: { label: string; value: string | number | boolean }) {
    if (this.multiSelect()) {
      if (this.value.includes(option.value)) {
        this.value = this.value.filter(v => v !== option.value);
      } else {
        const value = [...this.value];
        value.push(option.value);
        this.value = value;
      }
    } else {
      this.value = [option.value];
    }
    this.onChange(this.value);
    this.onTouched();
  }
}
